import React, {useEffect} from "react";
import * as StorageService from "../services/StorageService.js";
import {LOCALSTORAGE_ITEMS, ORDER_PLACE} from "../util/Constants";
import {PATH} from "../routes/routes";
import * as AccountService from "../services/AccountService";
import {clearStorageItems, handleAppVersionUpdate} from "../util/common";
import {getShopDetailsByName} from "../services/ShopService";
import {useLocation, useNavigate} from "react-router";
import {useParams} from "react-router-dom";

function LinkScan(props) {

    const navigateTo = useNavigate();
    const {shopName, page} = useParams();
    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const canceledReservationQuery = query.get('type');
    useEffect(() => {

        handleAppVersionUpdate();

        clearStorageItems();

        StorageService.setItem(LOCALSTORAGE_ITEMS.SHOP_NAME, shopName);

        if (!page) {// home
            navigateTo(PATH.MAIN);
            StorageService.setItem(LOCALSTORAGE_ITEMS.HAS_BACK_BUTTON, "true");

        }else if (page  === "reservation") {
            (async () => {
                await getShopDetailsByName(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME)).then(shopDetailsResponse=>{
                    StorageService.setItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS, JSON.stringify(shopDetailsResponse?.data));
                    StorageService.setItem(LOCALSTORAGE_ITEMS.HAS_BACK_BUTTON, "false");
                    if (canceledReservationQuery === "cancel" && !StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL)) {
                        //TODO useNavigate with search params
                        navigateTo({
                            pathname:  PATH.LOGIN,
                            search: "?redirect="+PATH.ALL_RESERVATIONS,
                        });
                    }else{
                        AccountService.configApp().then(r=> {
                            navigateTo(PATH.ALL_RESERVATIONS);
                        });

                    }
                });
            })();

        }else if (page  === "takeaway") {
            AccountService.configApp().then(r=> {
                navigateTo(PATH.TAKEAWAY);
                StorageService.setItem(LOCALSTORAGE_ITEMS.HAS_BACK_BUTTON, "false");
                StorageService.setItem(LOCALSTORAGE_ITEMS.ORDER_PLACE, ORDER_PLACE.TAKEAWAY);
            });
        }

    }, []);

    return (
        <div className="redirect-msg">
            Redirecting...
        </div>

    );
}

export default LinkScan;
